import React from 'react'
import "../holiday.scss"
import HolidaySearchBan from './HolidaySearchBan'
import Explore from './Explore'
import PackageCategorybyTheme from './PackageCategorybyTheme'
import AllHolidayPackagesbyDestination from './AllHolidayPackagesbyDestination'
import Seo from '../../helmet/Helmet'

function HolidayHome() {
    return (
        <>
            <Seo
                title="Book Customized Holiday Packages Deals | Explore with SuperbWorldTrip"
                description="Superb your travel affordable! Book holiday packages online with SuperbWorldTrip and save upto 10% on domestic & worldwide trips."
                link="/holiday"
                keywords="Affordable flights, budget air tickets, discount flight tickets, flight booking offers, lowest airfare deals, cheapest flights online, airfare comparison, best flight deals, last-minute flight tickets, international flight bookings, flight booking discounts, airline tickets cheap, book flights online, flight reservation, best prices on flights, find cheap flights, discounted airfares, online flight booking, air ticket deals"
                largeTwitterCard={true}
                addPostfixTitle={false}
                noIndex={true}
            />
            <HolidaySearchBan />
            <AllHolidayPackagesbyDestination />
            <PackageCategorybyTheme />
            <Explore />

        </>
    )
}

export default HolidayHome